import { useEffect } from 'react';
import { useTheme } from './ThemeProvider';
import { Capacitor } from '@capacitor/core';

/**
 * Custom hook to sync navigation bar colors with the current theme
 * Updates the EdgeToEdge plugin with solid, opaque colors
 */
export const useNavigationBarTheming = () => {
  const { theme } = useTheme();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const updateNavigationBarColors = async () => {
      try {
        // Import EdgeToEdge dynamically to avoid issues on web
        const { EdgeToEdge } = await import('@capawesome/capacitor-android-edge-to-edge-support');
        
        // Get theme-specific colors - ensure they're solid/opaque
        let barColor = '#111827'; // default dark
        
        switch (theme) {
          case 'light':
            barColor = '#ffffff'; // solid white
            break;
          case 'dark':
            barColor = '#111827'; // solid dark gray
            break;
          case 'lcars':
            barColor = '#ff9f40'; // solid LCARS orange
            break;
        }
        
        // Update the EdgeToEdge plugin with solid theme color
        await EdgeToEdge.setBackgroundColor({ color: barColor });
        
        console.log(`[NavigationBarTheming] Updated to ${theme} theme with solid color: ${barColor}`);
      } catch (error) {
        console.warn('[NavigationBarTheming] Failed to update colors:', error);
      }
    };

    // Update immediately when theme changes
    updateNavigationBarColors();
    
    return () => {
      // Cleanup if needed
    };
  }, [theme]);
};